import { Capacitor } from '@capacitor/core';

/** Match mobile list / narrow chrome (phones, native WKWebView, coarse pointers). */
export const NARROW_LAYOUT_MEDIA = '(max-width: 768px), (hover: none) and (pointer: coarse)';

/**
 * Phone / small tablet: bottom nav and full-screen list or detail (not split).
 * A phone in landscape is wider than 900px and shorter than 520px. iPad landscape
 * stays tall, so it keeps the split layout. Keep this in sync with the same
 * query in component stylesheets.
 */
export const COMPACT_SHELL_MEDIA =
  '(max-width: 900px), (max-height: 520px) and (pointer: coarse)';

export function prefersNarrowLayout(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  if (Capacitor.isNativePlatform()) {
    return true;
  }
  return window.matchMedia(NARROW_LAYOUT_MEDIA).matches;
}

export function prefersCompactShell(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  // A native phone stays on the same full-screen flow as Chrome mobile, including landscape,
  // where the window width can pass 900px. iPad still follows the width check.
  if (isNativePhone()) {
    return true;
  }
  return window.matchMedia(COMPACT_SHELL_MEDIA).matches;
}

function isNativePhone(): boolean {
  if (!Capacitor.isNativePlatform() || typeof navigator === 'undefined') {
    return false;
  }
  if (/iPad/i.test(navigator.userAgent)) {
    return false;
  }
  if (/iPhone|iPod/i.test(navigator.userAgent)) {
    return true;
  }
  const shortSide = Math.min(window.screen.width, window.screen.height);
  return shortSide > 0 && shortSide <= 500;
}
